export class PermissionTypeDto {
    read = false;
    write = false;
    analyze = false;
    delete = false;
}
